import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/authentication/Login'
import Homepage from '@/components/Homepage'
import Influencers from '@/components/influencer/Influencers'
import InfluencersHash from '@/components/influencer/InfluencersHash'
import InfluencersCompare from '@/components/influencer/InfluencersCompare'
import InfluencerCreate from '@/components/influencer/InfluencerCreate'
import Influencer from '@/components/influencer/Influencer'
import InfluencerAsk from '@/components/influencer/InfluencerAsk'
import AudienceListInstagram from "@/components/audience/instagram/AudienceList.vue";
import AudienceCreateInstagram from "@/components/audience/instagram/AudienceCreate.vue";
import ProfileWaitingList from "@/components/waitingProfile/ProfileWaitingList.vue";
import AudienceListTiktok from "@/components/audience/tiktok/AudienceListTiktok.vue";
import AudienceCreateTiktok from "@/components/audience/tiktok/AudienceCreateTiktok.vue";
import InfluencerRegisterList from "@/components/influencer/register/InfluencerRegisterList.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: Login,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/home',
      component: Homepage,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/influencers',
      component: Influencers,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/influencer/edit/:id',
      component: InfluencerCreate,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/influencer/show/:id',
      component: Influencer,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/influencer/ask/:id',
      component: InfluencerAsk,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/influencer/new',
      component: InfluencerCreate,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/influencers/hash',
      component: InfluencersHash,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/influencers/compare',
      component: InfluencersCompare,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/audience/list',
      component: AudienceListInstagram,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/audience/create/:instagramId/:username',
      component: AudienceCreateInstagram,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/audience/tiktok/list',
      component: AudienceListTiktok,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/audience/tiktok/create/:tiktokId/:username',
      component: AudienceCreateTiktok,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/profile/waiting/list',
      component: ProfileWaitingList,
      meta: {
        forAuth: true
      }
    },
    {
      path: '/influencer/register/list',
      component: InfluencerRegisterList,
      meta: {
        forAuth: true
      }
    }


  ]
});




// WEBPACK FOOTER //
// ./src/router/index.js